import { Experiment } from '@ms/yammer-data/dist/state/types';
import { SettingsTeachingBubbleForRoleBasedFRE } from '@ms/yammer-role-based-fre';
import { ComponentProps } from 'react';

import { useAndReportExperimentTreatment } from '../experiments';

import { useShowSettingsTeachingBubble } from './selectors';
import { useCloseSettingsTeachingBubbleCallback } from './useCloseSettingsTeachingBubbleCallback';

type UseSettingsTeachingBubbleProps = (target: string) => Omit<
  ComponentProps<typeof SettingsTeachingBubbleForRoleBasedFRE>,
  'children'
> & {
  readonly isExperimentEnabled: boolean;
};
export const useSettingsTeachingBubbleProps: UseSettingsTeachingBubbleProps = (target) => {
  const isSettingsTeachingBubbleEnabled = useAndReportExperimentTreatment(Experiment.RoleBasedFRE) === 'enabled';
  const openSettingsTeachingBubble = useShowSettingsTeachingBubble();
  const closeSettingsTeachingBubbleCallback = useCloseSettingsTeachingBubbleCallback();

  return {
    isExperimentEnabled: isSettingsTeachingBubbleEnabled,
    target,
    isOpen: openSettingsTeachingBubble,
    onOpenChange: closeSettingsTeachingBubbleCallback,
  };
};
